module.exports = __webpack_public_path__ + "img/landing.5a09a9f3.gif";